<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <printer-form />
      </div>
    </div>
  </section>
</template>

<script>
import printerForm from './Temp/PrinterFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'printer-form': printerForm
  },
  methods: {
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrPrinter.vue?4d2d5382